
import { State, Action, actionTypes, TOAST_LIMIT } from "./types"
import { addToRemoveQueue } from "./toast-utils"

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case actionTypes.ADD_TOAST:
      // Check if there's already a toast with the same title and description
      const isDuplicate = state.toasts.some(
        t => 
          t.title === action.toast.title && 
          t.description === action.toast.description &&
          t.open // Only consider open toasts as duplicates
      );
      
      // If it's a duplicate, don't add it
      if (isDuplicate) {
        return state;
      }
      
      // Add toast to the queue and auto-dismiss after 5 seconds
      const newToast = { ...action.toast };
      
      // For all toasts, add to remove queue for auto-dismissal
      setTimeout(() => {
        dispatch({
          type: actionTypes.DISMISS_TOAST,
          toastId: newToast.id,
        });
      }, 5000);
      
      return {
        ...state,
        toasts: [newToast, ...state.toasts].slice(0, TOAST_LIMIT),
      }

    case actionTypes.UPDATE_TOAST:
      return {
        ...state,
        toasts: state.toasts.map((t) =>
          t.id === action.toast.id ? { ...t, ...action.toast } : t
        ),
      }

    case actionTypes.DISMISS_TOAST: {
      const { toastId } = action

      // ! Side effects ! - This could be extracted into a dismissToast() action,
      // but I'll keep it here for simplicity
      if (toastId) {
        addToRemoveQueue(toastId)
      } else {
        state.toasts.forEach((toast) => {
          addToRemoveQueue(toast.id)
        })
      }

      return {
        ...state,
        toasts: state.toasts.map((t) =>
          t.id === toastId || toastId === undefined
            ? {
                ...t,
                open: false,
              }
            : t
        ),
      }
    }
    case actionTypes.REMOVE_TOAST:
      if (action.toastId === undefined) {
        return {
          ...state,
          toasts: [],
        }
      }
      return {
        ...state,
        toasts: state.toasts.filter((t) => t.id !== action.toastId),
      }
  }
}

// External state and dispatch handling
export const listeners: Array<(state: State) => void> = []

// Create initial state
let _memoryState: State = { toasts: [] }

// Export a getter for the current state
export const getState = () => _memoryState

// Export a setter for the state
export const setState = (newState: State) => {
  _memoryState = newState
}

// Import this to avoid circular dependencies
import { dispatch } from "./toast-store"
